import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Auth from '../views/Auth.vue'
import UserChat from '../views/UserChat.vue'
import ThemeList from '../views/ThemeList.vue'
import Control from '../views/Control.vue'
import NotFound from '../views/NotFound.vue'

import store from '../store'

function IsAuthorized() {
    return localStorage.getItem("tok") != null
}

const lockPages = false

const routes = [{
        path: '/',
        name: 'Home',
        component: Home,
        beforeEnter: () => {
            if (lockPages) {
                router.push({ name: 'UserChat' })
                return
            }
            if (!IsAuthorized()) {
                router.push({ name: 'Auth' })
            }
        }
    },
    {
        path: '/themes',
        name: 'Themes',
        component: ThemeList,
        beforeEnter: () => {
            if (lockPages) {
                router.push({ name: 'UserChat' })
                return
            }
            if (!IsAuthorized()) {
                router.push({ name: 'Auth' })
            }
        }
    },
    {
        path: '/control',
        name: 'Control',
        component: Control,
        beforeEnter: () => {
            if (lockPages) {
                router.push({ name: 'UserChat' })
                return
            }
            if (!IsAuthorized()) {
                router.push({ name: 'Auth' })
            }
        }
    },
    {
        path: "/user_chat",
        name: "UserChat",
        component: UserChat,
        beforeEnter: () => {
            if (!lockPages && !IsAuthorized()) {
                router.push({ name: 'Auth' })
                return
            }
        }
    },
    {
        path: '/auth',
        name: 'Auth',
        component: Auth,
        beforeEnter: () => {
            if (lockPages) {
                router.push({ name: 'UserChat' })
                return
            }
            if (IsAuthorized()) {
                router.push({ name: 'Home' })
            }
        }
    },
    {
        path: '/logout',
        name: 'Logout',
        beforeEnter: () => {
            if (lockPages) {
                router.push({ name: 'UserChat' })
                return
            }
            const mode = localStorage.getItem("mode")
            localStorage.clear()
            if (mode !== null) {
                localStorage.setItem("mode", mode)
            }
            try {
                fetch(store.state.supportApiAddr + "/v1.0/users/logout", {
                    method: "GET",
                    credentials: 'include',
                })
            } catch (e) {
                console.log(e)
            }

            router.push({ name: 'Auth' })
        }
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFound,
        beforeEnter: () => {
            if (lockPages) {
                router.push({ name: 'UserChat' })
                return
            }
        }
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router